export default __webpack_public_path__ + "static/img/digital-profile.ce419c7.png";